// Theme management with localStorage persistence + lock
export const THEME_KEY = 'islandride-theme';
export const LOCK_KEY = 'islandride-theme-locked';
export const DEFAULT_THEME = 'theme-a';

export function applyTheme(theme) {
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = theme;
  }
}

export function getStoredTheme() {
  if (typeof window === 'undefined') return DEFAULT_THEME;
  return localStorage.getItem(THEME_KEY) || DEFAULT_THEME;
}

export function setStoredTheme(theme) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(THEME_KEY, theme);
  applyTheme(theme);
}

export function isThemeLocked() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(LOCK_KEY) === '1';
}

export function lockTheme() {
  if (typeof window === 'undefined') return;
  localStorage.setItem(LOCK_KEY, '1');
}

export function unlockTheme() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(LOCK_KEY);
}

export function initTheme() {
  applyTheme(getStoredTheme());
}
